import {config} from "../config/config.ts";

/**
 * Quiz funnels whose answers this browser holds, by the localStorage key of their quiz_responses
 * row. /scorepal-quiz/'s own signup form sends its key with the signup, but its Google button and
 * its "create it now" hand-off to /quiz/ leave before an account exists, so those signups never
 * reached the row and the report counted 0 signed up.
 */
const QUIZ_KEYS = ['sp_sq_rkey'];
const CLAIMED_KEY = 'sp_quiz_claimed';

/**
 * Once signed in, link each quiz row this browser started to the account, once per row. The server
 * links only a row that exists and has no account yet, and only for an account made in the last
 * few days (QuizController::response), so a returning player is never counted as a quiz signup.
 */
export function claimQuizResponses() {
    try {
        const token = localStorage.getItem('jwt_token');
        if (!token) return;
        const claimed = (localStorage.getItem(CLAIMED_KEY) || '').split(',').filter(Boolean);
        for (const storageKey of QUIZ_KEYS) {
            const key = localStorage.getItem(storageKey);
            if (!key || claimed.includes(key)) continue;
            claimed.push(key);
            localStorage.setItem(CLAIMED_KEY, claimed.slice(-10).join(','));
            fetch(config.apiUrl + '/quiz/response', {
                method: 'POST',
                headers: {'Content-Type': 'application/json', 'Accept': 'application/json', Authorization: 'Bearer ' + token},
                body: JSON.stringify({key, claim: true}),
                keepalive: true,
            }).catch(() => {});
        }
    } catch { /* private mode: nothing to link */ }
}
